import React from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar'
import { useTranslation } from 'react-i18next';



const BlogList = ({ categories, tags, paginatedBlogs, handlePageChange, handleFilter, currentPage, totalPages }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();

    return (
        <section className="wpo-blog-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 `}>
                        <div className="wpo-blog-content">
                            {paginatedBlogs.slice(0, 4).map((blog, bitem) => (
                                <div className={`post  ${blog.blClass}`} key={bitem}>
                                    <div className="entry-media ">
                                        <img src={`${process.env.REACT_APP_API_URL}/api/images/${blog?.data?.thumbnail}`} alt="" />
                                    </div>
                                    <div className="entry-meta">
                                        <ul>
                                            <li> By <Link to="/blog-single/1">{blog?.data?.author}</Link> </li>
                                            <li> {blog?.publishedAt.slice(0, 10)}</li>
                                        </ul>
                                    </div>
                                    <div className="entry-details">
                                        <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog?.data?.title}</Link></h3>
                                        <p>{blog?.data?.description.slice(0, 100)}</p>
                                        <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`} className="read-more">{t('readMore')}...</Link>
                                    </div>
                                </div>
                            ))}

                            <div className="pagination-wrapper pagination-wrapper-left">
                                <ul className="pg-pagination">
                                    <li>
                                        <button onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1 || totalPages === 0} aria-label="Previous">
                                            <i className="fi ti-angle-left"></i>
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                                        <li className={page === currentPage ? "active" : ""} key={page}>
                                            <button

                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page.toString().padStart(2, "0")}
                                            </button>
                                        </li>
                                    ))}
                                    <li>
                                        <button onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages || totalPages === 0} aria-label="Next">
                                            <i className="fi ti-angle-right"></i>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <BlogSidebar categories={categories} tags={tags} />
                </div>
            </div>
        </section>

    )

}

export default BlogList;
